import '../scss/main.scss';
import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';

window.addEventListener('DOMContentLoaded', () => {
	const controller = new ScrollMagic.Controller();

	let moduleContactAgentWrappers = document.querySelectorAll('.content-wrapper.module-contact-agents');
	moduleContactAgentWrappers = [].slice.call(moduleContactAgentWrappers);

	moduleContactAgentWrappers.forEach(moduleContactAgentWrapper => {
		const agentContainers = moduleContactAgentWrapper.querySelectorAll('.agent');

		const agentsTimeline = new TimelineMax();

		agentContainers.forEach((agentContainer, index) => {
			agentsTimeline.from(agentContainer, .5, { y: '-=60px', autoAlpha: 0 }, 'animboxTextIn+=' + (index * 0.15));
		});

		new ScrollMagic.Scene({
			triggerElement: moduleContactAgentWrapper,
			triggerHook: 'onEnter',
			offset: '200',
			reverse: false
		})
			.setTween(agentsTimeline)
			.addTo(controller);
	});
});